import { Component, Input } from '@angular/core';
import { FeUtil } from '../../../hezky-routes';
@Component({
  selector: 'app-incident-form-report',
  templateUrl: './incident-form-report.component.html',
})
export class IncidentFormReportComponent {
  @Input({ required: true }) formReportData: any;

  constructor(protected readonly feUtil: FeUtil) {}
}
